export class ProductToolData {
  public id: string // if this is a tooldata rather than product tool data, then this will be tool id
  public toolId: string
  public displayOrder: number
  constructor(pToolId: string, pDisplayOrder: number) {
    this.toolId = pToolId
    this.displayOrder = pDisplayOrder
  }
}
